/*
 * @Author: your name
 * @Date: 2020-11-13 17:12:42
 * @LastEditTime: 2020-11-26 16:06:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /da-system/src/newzealand/api/chatroom.js
 */
import request from '@/utils/request'


/*统计数量 */
export function getDataCount() {
  return request({
    url: '/newzealand/api/index/queryNumberPage',
    method: 'get'
  })
}

/* 查询人员详情 */
export function validateToken(params) {
  return request({
    url: '/newzealand/api/index/checkToken',
    method: 'get',
    params: params
  })
}


/* 查询人员详情 */
export function getPersonsByid(params) {
  return request({
    url: '/newzealand/api/persons/searchbyid',
    method: 'get',
    params: params
  })
}

/*随机推荐五个机构人员 */
export function getFivePersons() {
  return request({
    url: '/newzealand/api/persons/getFivePersons',
    method: 'get'
  })
}

/*随机推荐五个涉hua人员 */
export function getFiveHuaPersons() {
  return request({
    url: '/newzealand/api/persons/getFiveHuaPersons',
    method: 'get'
  })
}


/*综合检索人员列表 */
export function getPersonsPage(params) {
  return request({
    url: '/newzealand/api/persons/getPersonsPage',
    method: 'post',
    data: params
  })
}
/*综合检索涉hua人员列表 */
export function getHuaPersonsPage(params) {
  return request({
    url: '/newzealand/api/persons/getHuaPersonsPage',
    method: 'post',
    data: params
  })
}

/**
 * 根据PersonsId拿取关系图数据
 */
export function selectPersonsEndorsor(params) {
  return request({
    url: '/newzealand/api/persons/selectPersonsEndorsor',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/persons.js